import * as React from 'react';
import { Record, RecordTypes, Logger } from '../../stores/logger/Logger';

class Notifications extends React.Component<{ location: Location, logger: Logger }, {}> {
  componentDidUpdate(prevProps) {
    const locationChanged = this.props.location !== prevProps.location;

    this.props.logger.clearAlerts();
  }

  public render() {
    const alerts = this.props.logger.getAlerts().map((alert, index) => {
      let alertClass = 'alert alert-warning';
      switch(alert.level) {
        case RecordTypes.ERROR:
          alertClass = 'alert alert-warning';
          break;
          case RecordTypes.INFO:
          alertClass = 'alert alert-primary';
          break;
      }
      return <div className={alertClass} role="alert" key={"row-" + index.toString()}>{alert.message}</div>
    });

    return (

      <React.Fragment>
        {alerts}
      </React.Fragment>
    )
  }
}

export default Notifications;



// WEBPACK FOOTER //
// ./src/components/notifications/Notifications.tsx